import React from 'react';

/**
 * Forward ref for a component with generic props
 *
 * @param render The component render function
 * @param displayName The display name of the component
 *
 * @see https://www.totaltypescript.com/forwardref-with-generic-components
 * @see https://react.dev/reference/react/forwardRef
 */
export function forwardRefWithGeneric<T, P = unknown>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode,
  displayName?: string,
): // Cannot use React.ForwardRefExoticComponent because it does not support generic props
// Attempting to use React.ForwardRefExoticComponent here will results in typing error
// both in the component and in the component's consumer code
(props: React.PropsWithoutRef<P> & React.RefAttributes<T>) => React.ReactNode {
  const fn = React.forwardRef(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render as any,
  ) as React.ForwardRefExoticComponent<
    React.PropsWithoutRef<P> & React.RefAttributes<T>
  >;
  fn.displayName = displayName ?? render.name;
  return fn;
}
